module.exports = __webpack_public_path__ + "static/media/user-settings-flowchart.7c2ea397.png";